const paymentFr = {
    "billing": {
        "name": "Nom/Nom de l'entreprise",
        "country": "Pays",
        "postal_code": "Code Postal",
        "city": "Ville",
        "address": "Adresse",
        "tax_number": "Numéro fiscal",
        "phone": "Numéro de téléphone",
        "tax_number_helper_text": "Obligatoire pour les entreprises, non obligatoire pour les particuliers",
        "billing_info": "Informations de facturation",
        "emails_helper_text": "Facultatif. Pour plusieurs adresses e-mail, séparez-les par des virgules."
    },
    "subscription_plans": {
        "PRO": "Plan Pro",
        "FREE": "Plan gratuit"
    },
    "plan_descriptions": {
        "PRO": "Pour les restaurants qui souhaitent développer leur activité ! Traduisez votre menu dans de nouvelles langues en quelques clics, sollicitez l’avis de vos clients sur leurs plats, suivez l’utilisation de votre menu par QR code grâce à des statistiques utiles, ou laissez QuickPick AI répondre automatiquement aux commentaires de vos clients selon vos souhaits !",
        "FREE": "Pour les restaurants qui souhaitent se lancer dans la distribution de menus en ligne et l'utilisation de codes QR."
    },
    "subscription_status": {
        "ACTIVE": "Actif",
        "CANCELLED": "Annulé"
    },
    "next_billing_date": "Prochaine date de facturation",
    "current_subscription": "Abonnement actuel",
    "cancel": "Annuler",
    "subscription_interval_prices": {
        "MONTHLY": "mois",
        "YEARLY": "année",
        "HALF_YEARLY": "semestre",
        "QUARTERLY": "quart"
    },
    "subscription_interval_payment_name": {
        "MONTHLY": "Abonnement mensuel",
        "YEARLY": "Abonnement annuel",
        "HALF_YEARLY": "abonnement semestriel",
        "QUARTERLY": "Abonnement trimestriel"
    },
    "reactivate": "Réactiver",
    "valid_to": "Valable jusqu'au",
    "payments_and_invoices": "Paiements et factures",
    "amount": "Montant",
    "invoice": "Facture",
    "update_card": "Mise à jour",
    "payment_method": "Mode de paiement",
    "cancel_subscription_confirmation": "Êtes-vous sûr de vouloir annuler votre abonnement actuel ?",
    "cancel_subscription_valid_until": "L'abonnement restera valable jusqu'à la date suivante",
    "subscription_cancelled": "Abonnement annulé avec succès",
    "reactivate_confirmation": "Êtes-vous sûr de vouloir réactiver l'abonnement annulé ?",
    "reactivate_successful": "L'abonnement a été réactivé avec succès.",
    "change_payment_method": "Changer le mode de paiement",
    "change_payment_method_tooltip": "Pour modifier vos informations de paiement, vous devez régler votre abonnement pour la période suivante. Votre abonnement sera alors prolongé d'autant de temps et la prochaine facturation sera reportée d'autant de temps.",
    "amount_to_be_paid": "Montant à payer",
    "new_subscription_valid_until": "nouvelle validité de l'abonnement",
    "bank_card_expires_soon": "La carte bancaire utilisée pour l'abonnement expirera bientôt.",
    "reactivate_subscription_confirmation": "Êtes-vous sûr de vouloir réactiver l'abonnement annulé ?",
    "billing_information": "Informations de facturation",
    "edit_billing_information": "Modifier les informations de facturation",
    "no_available_invoices": "Aucune facture disponible",
    "subscribe": "S'abonner",
    "continue_to_payment": "Poursuivre le paiement",
    "confirm_subscription": "Confirmer l'abonnement",
    "subscription_page_title": "Démarrer l'abonnement",
    "pay": "Paiement",
    "available_plans": "Abonnement disponible",
    "accept_terms_and_conditions": "J'ai lu et j'accepte les <a>Conditions générales</a>",
    "accept_recurring_payments": "En payant, j'accepte le prélèvement automatique des paiements récurrents, que je peux annuler à tout moment.",
    "accept_privacy_policy": "J'ai lu et j'accepte la <a>Politique de confidentialité</a>",
    "subscribe_soon": "À venir"
};

export default paymentFr;
